import React, { Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'; 
// import { BrowserRouter as Router, Route } from 'react-router-dom'; 
import './App.css';
import Welcome from './components/Welcome';
import Privacy from './components/Privacy';
import Cookies from './components/Cookies';
import ChildSafety from './components/ChildSafety';
import TermsOfService from './components/TermsOfService';
import SignUp from './components/SignUp'
import SignUpCS from './components/SignUpCS'
import SignUpSuccess from './components/SignUpSuccess'
import SignIn from './components/SignIn'
import ForgotPassword from './components/ForgotPassword'
import ResetPassword from './components/ResetPassword'
import Home from './components/Home'
import ChangeEmail from './components/ChangeEmail'
import ChangePassword from './components/ChangePassword'
import ManageSubscription from './components/ManageSubscription'
import AffiliateDashboard from './components/AffiliateDashboard'
import AffiliateLanding from './components/AffiliateLanding'
import Rules from './components/Rules'
import HowToFriends from './components/HowToFriends'
import HowToCommunity from './components/HowToCommunity'
import HowToPowerLevel from './components/HowToPowerLevel'
import HowToMessages from './components/HowToMessages'
import HowToProfile from './components/HowToProfile'
import HowToEventsMeetups from './components/HowToEventsMeetups'
import PauseAccount from './components/PauseAccount'
import DeleteAccount from './components/DeleteAccount'
import AcceptSignUp from './components/AcceptSignUp'
import CommunitySignUp from './components/CommunitySignUp'
import SignUpInfo from './components/SignUpInfo'
import SignUpConfirmation from './components/SignUpConfirmation'
import CommunitySignUpConfirmation from './components/CommunitySignUpConfirmation'
import VerifyEmail from './components/VerifyEmail'
import CreateEventOpportunity from './components/CreateEventOpportunity'
import EventDetail from './components/EventDetail'
import NotFound from './components/NotFound'
import ScrollToTop from './components/ScrollToTop'

class App extends Component {
  constructor() {
    super();
    this.state = {};
  };
  render() {
    return (
      <BrowserRouter>
          <ScrollToTop />
          <Routes>
          
            <Route path="/" exact element={ <Welcome /> } />

            <Route path="/coming-soon" exact element={ <Welcome /> } />

            <Route path="/terms-of-service" exact element={ <TermsOfService /> } />

            <Route path="/privacy" exact element={ <Privacy /> } />

            <Route path="/cookies" exact element={ <Cookies /> } />

            <Route path="/child-safety" exact element={ <ChildSafety /> } />

            <Route path="/signin" exact element={ <SignIn /> } />

            <Route path="/forgot-password" exact element={ <ForgotPassword /> } />

            <Route path="/reset-password/:id/:token" exact element={ <ResetPassword /> } />

            <Route path="/home" exact element={ <Home /> } />

            <Route path="/change-email" exact element={ <ChangeEmail /> } />

            <Route path="/change-password" exact element={ <ChangePassword /> } />

            <Route path="/manage-subscription" exact element={ <ManageSubscription /> } />

            <Route path="/affiliate" exact element={ <AffiliateDashboard /> } />

            <Route path="/rules" exact element={ <Rules /> } />

            <Route path="/how-to-friends" exact element={ <HowToFriends /> } />

            <Route path="/how-to-community" exact element={ <HowToCommunity /> } />

            <Route path="/how-to-power-level" exact element={ <HowToPowerLevel /> } />

            <Route path="/how-to-messages" exact element={ <HowToMessages /> } />

            <Route path="/how-to-profile" exact element={ <HowToProfile /> } />

            <Route path="/how-to-events" exact element={ <HowToEventsMeetups /> } />

            <Route path="/pause-account" exact element={ <PauseAccount /> } />

            <Route path="/delete-account" exact element={ <DeleteAccount /> } />

            <Route path="/signup" exact element={ <SignUp /> } />

            <Route path="/signup-success" exact element={ <SignUpSuccess /> } />

            <Route path="/signup-cs" exact element={ <SignUpCS /> } />

            <Route path="/signup/continue" exact element={ <AcceptSignUp /> } />

            <Route path="/signup/community" exact element={ <CommunitySignUp /> } />

            <Route path="/signup-info/:plan" exact element={ <SignUpInfo /> } />

            <Route path="/signup-info/:plan/:success" exact element={ <SignUpInfo /> } />

            <Route path="/signup-confirmation" exact element={ <SignUpConfirmation /> } />

            <Route path="/signup-confirmation-community" exact element={ <CommunitySignUpConfirmation /> } />

            <Route path="/create-event-opportunity" exact element={ <CreateEventOpportunity /> } />

            <Route path="/verify-email/:id/:token" exact element={ <VerifyEmail /> } />

            <Route path="/e/:slug" exact element={ <EventDetail /> } />

            <Route path="/:displayName" exact element={ <AffiliateLanding /> } />

            <Route path="*" element={ <NotFound /> } />

        </Routes>

      </BrowserRouter>
    );
  };
};
export default App;